import { css, Theme } from "@emotion/react"

export const bannerStyle = (theme: Theme) => css`
	text-align: center;
	font-size: 14px;
	text-decoration-skip-ink: none;
	background-color: #0b75e1;
	display: flex;
	justify-content: center;
	color: #fff;
	padding: 0.8rem 2rem;
	position: relative;
	align-items: center;
	flex-direction: row;

	a {
		margin-left: 1rem;
	}

	div {
		display: flex;
		align-items: center;
	}

	svg {
		margin-right: 1rem;
	}

	${theme.breakpoints.down("md")} {
		flex-direction: column;
	}

	button {
		position: absolute;
		right: 1rem;
		top: 0.3rem;
	}
`
